import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { products } from '../data/products';
export function FeaturedProducts() {
  const {
    addItem
  } = useCart();
  // Select a few specific products to feature
  const featured = [products[0], products[14], products[1], products[8]];
  return <section className="py-24 bg-uncommon-dark border-y border-uncommon-grey" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-42">
          <div data-id="element-43">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-44">
              TRENDING <span className="text-uncommon-gold" data-id="element-45">N</span>OW
            </h2>
            <p className="text-gray-400" data-id="element-46">
              Fresh drops and community favorites.
            </p>
          </div>
          <Button variant="secondary" data-id="element-47">View All Products</Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-48">
          {featured.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-49">
              {/* Image Container */}
              <div className="relative aspect-[3/4] overflow-hidden rounded-lg bg-uncommon-black mb-4 border border-uncommon-grey group-hover:border-uncommon-gold/50 transition-colors" data-id="element-50">
                {product.badge && <div className="absolute top-3 left-3 z-10 bg-uncommon-gold text-black text-xs font-bold px-2 py-1 uppercase tracking-wider" data-id="element-51">
                    {product.badge}
                  </div>}
                <button className="absolute top-3 right-3 z-10 p-2 rounded-full bg-black/50 text-white hover:bg-uncommon-gold hover:text-black transition-colors opacity-0 group-hover:opacity-100" data-id="element-52">
                  <Heart size={16} data-id="element-53" />
                </button>
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-54" />
                <div className="absolute inset-x-0 bottom-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-55">
                  <Button variant="primary" fullWidth className="text-xs py-2" onClick={() => addItem(product)} data-id="element-56">
                    Add to Cart
                  </Button>
                </div>
              </div>

              {/* Info */}
              <div data-id="element-57">
                <p className="text-xs text-uncommon-gold uppercase tracking-wider mb-1" data-id="element-58">
                  {product.category}
                </p>
                <h3 className="text-lg font-bold text-white mb-1 group-hover:text-uncommon-gold transition-colors" data-id="element-59">
                  {product.name}
                </h3>
                <p className="text-gray-300 font-medium" data-id="element-60">
                  ${product.price.toFixed(2)}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}